import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getLiHtml = ((node: Block | Inline, next: Next) =>
  `<li>${next(node.content)} </li>`) as NodeRenderer;
